import React, { useContext, useEffect, useRef, useState } from "react";
// jquery
import $ from "jquery";
// React Bootstrap
import { Button, Col, Form, FormControl, InputGroup, Navbar } from "react-bootstrap";
// Componentes
import TablaDestinos from "./destinosComunitarios/TablaDestinos";
import FormDestino from "./destinosComunitarios/FormDestino"
import TooltipIcon from "../generic/TooltipIcon";
// Custom spinner
import CustomSpinner from "../generic/CustomSpinner";
// Contexto
import { ModalContext } from "../../context/modalContext";
import { AlertBoxContext } from "../../context/alertBoxContext";
import { datosHermanas } from "../../contexto";
// Styled Components
import styled from "styled-components";
// Utils
import { addYears, dateToString2 } from "../../utils";
// Hooks
import { useIsMount } from "../hooks/UseIsMount";
import useObserver from "../hooks/UseObserver";

const CustomNavBar = styled(Navbar)`
  min-width: 200px;
  padding: 0px;
  margin: 0px;
  padding-top: 10px;
`;

const CustomTable = styled.div`
  position: relative;
  overflow: auto;
  max-height: 500px;
`;

const DestinosComunitarios = ({ type, idEntidad, idSubEntidad = "", permisoEdicion, userLevel }) => {
  // Spinner
  const [loading, setLoading] = useState(false);

  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  //042022 Datos hermanas
  const [datosHermanasComunidad, setDatosHermanasComunidad] = useState([]);

  // Filtros, paginación y observador
  const [page, setPage] = useState(1); // Página por la que va
  const [lastPageReached, setLastPageReached] = useState(false); // ultima pagina alcanzada
  const [reload, setReload] = useState(false); // Reload para recargar el observador
  const [isActive, setIsActive] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filtroCargo, setFiltroCargo] = useState("");
  
  const isMount = useIsMount(); // Se renderiza por primera vez?
  const scrollingDiv = useRef(null); // Div que contendrá el scroll

  // Resetea el explorador con los filtros actuales
  const resetCargos = () => {
    setPage(1);
    setReload(!reload);
  };

  //042022 leer hermanas
  useEffect(() => {
    handleGetDatosHermanasComunidad();
  }, [search])

  // Para volver a pedir los datos cuando cambia algun filtro
  useEffect(() => {
    if (!isMount) {
      resetCargos();
    }
    scrollingDiv.current.scrollTop = 0;
  }, [isActive, search, filtroCargo]);

  useEffect(() => {
    //handleGetCargos();
  }, [reload]);

  //para filtrar por fechas de inicio y fin de destinos
  useEffect(() => {
    if (datosHermanasComunidad && startDate && endDate) {
      handleGetDatosHermanasComunidad();
    }
  }, [startDate, endDate])

  // **************************************************** GET ************************************************
  //042022 Obtiene los datos de hermanas por comunidad
  const getDatosHermanasComunidad = (userId) => {
    const url = userId ? `${process.env.REACT_APP_API_URL}/usuarios/${userId}` : `${process.env.REACT_APP_API_URL}/usuarios?type=Monja&provincia=${idEntidad}&comunidad=${idSubEntidad}&page=1&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}`
    
    let settings = {
      url: url,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  //042022 Manejador para obtener los datos de la comunidad
  const handleGetDatosHermanasComunidad = () => {
    setLoading(true);
    getDatosHermanasComunidad()
      .then((response) => {
        setLoading(false);
        //removeEmptyFields(response);
        if (startDate && endDate) {
          const filtrados = response.items.filter(item => ((item.sister?.destinations[0]?.startDate >= startDate) && (item.sister?.destinations[0]?.endDate <= endDate)))
          setDatosHermanasComunidad({ page: 1, totalPages: Math.ceil(filtrados.length / 20), items: filtrados, totalItems: filtrados.length })
        } else {
          setDatosHermanasComunidad(response);
        }
      })
      .catch(() => {
        setLoading(false);
        
      });
  };

  // **************************************************** POST ************************************************
  //inserta destino
  const postDestino = (miData) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/hermanas/${miData.sisterId}/destino`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: miData,
    };
    return $.ajax(settings);
  }

  // manejador inserta destino
  const handlePostDestino = (data) => {


    setLoading(true);
    modalSetShow(false);
    //obtengo sisterId con el userIde del data
    getDatosHermanasComunidad(data.userId)
      .then((response) => {




        const miData = {
          sisterId: response.sister.id,
          startDate: data.startDate,
          endDate: data.endDate,
          communityId: idSubEntidad,
          provinceId: idEntidad,
        }

        postDestino(miData)
          .then((response) => {
            handleGetDatosHermanasComunidad();
            addAlert("Exito", `Se ha insertado el destino correctamente`, "success");
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
            addAlert("Error", `No se ha podido insertar el destino, verifique el destino y las fechas`, "danger");
          });


      })
      .catch((e) => {
        setLoading(false);
        addAlert("Error", ` Error 59`, "success");
        //props?.ErrorHandling();
      });

  }

  // **************************************************** PUT ************************************************
  //edita destino
  const putDestino = (miData) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/hermanas/${miData.hermanaId}/destino/${miData.destinoId}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: miData,
    };
    return $.ajax(settings);
  }

  // manejador edita destino
  const handlePutDestino = (data) => {





    setLoading(true);
    modalSetShow(false);

    const miData = {
      destinoId: data.sister.destinations[0].id,
      hermanaId: data.sister.id,
      startDate: data.startDate,
      endDate: data.endDate

    }

    putDestino(miData)
      .then((response) => {
        handleGetDatosHermanasComunidad();
        addAlert("Exito", `Se ha editado el destino correctamente`, "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", `No se ha podido editar el destino, verifique que las fechas estén entre +- 90 días`, "danger");
      });

  }

  // **************************************************** DELETE ************************************************
  //elimina destino
  const delDestino = (hermana, destino) => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/hermanas/${hermana}/destino/${destino}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  }

  // manejador elimina destino
  const handleDelDestino = (data) => {
    setLoading(true);
    modalSetShow(false);

    delDestino(data.sister.id, data.sister.destinations[0].id)
      .then(() => {
        handleGetDatosHermanasComunidad();
        addAlert("Exito", `Se ha eliminado el destino correctamente`, "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        addAlert("Error", `No se ha podido eliminar el destino por estar en vigor. Edítelo`, "danger");
      });
  }

  // **************************************************** UTILS ************************************************

  // Funcion que decide cuando se preasigna la fecha de endate en el formulario y cuando no tambien nos dice cuando cambiar la fecha de fin si cambia la fecha de inicio
  const handlerEndDate = () => {
    switch (type) {
      // Provinciales y dirección general
      case "hermanasComunidad":
        return false;
      default:
        return false;
    }
  };

  // Para manejar el cambio de fecha de los filtros
  const handleChangeStartDate = (e) => {
    setStartDate(e.target.value);
    setIsActive(false);
  };

  // Para manejar el cambio final de los filtros
  const handleChangeEndDate = (e) => {
    setEndDate(e.target.value);
    setIsActive(false);
  };

  // Para manejar el select de los cargos
  const handleChangeIsActive = (e) => {
    setStartDate("");
    setEndDate("");
    setIsActive(!isActive);
  };


  // **************************************************** OBSERVADOR ************************************************
  const loadMore = async () => {
    if (!lastPageReached && !loading) {
      handleGetDatosHermanasComunidad(true);
    }
  };

  const target = useRef(null);

  useObserver(
    loadMore,
    {
      root: scrollingDiv.current,
      rootMargin: "0px",
      threshold: 1,
    },
    target
  );

  

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />
      {/* Filtros */}
      <CustomNavBar expand="md">
        {/* Cuando se hace pequeña la pantalla */}
        <Navbar.Toggle>
          <span className="align-text-bottom"> Filtros</span>
        </Navbar.Toggle>
        <Navbar.Collapse>
          <Form as="div" className="w-100">
            <Form.Row>
              <Form.Group as={Col} xs={12} md>
                <div className={"d-flex "}>
                  <FormControl
                    className="mr-1"
                    type="text"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    placeholder={"Búsqueda"}
                  />
                  <TooltipIcon content={"Búsqueda por nombre, apellidos o documento de identidad."} />
                </div>
              </Form.Group>
              {/* Si no estmaos en representantes legales */}

            </Form.Row>
            {permisoEdicion && <Form.Row>
              <Form.Group as={Col} xs={12} md>
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Fecha inicio"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control type="date" max={endDate} value={startDate} onChange={handleChangeStartDate} />
                </InputGroup>
              </Form.Group>
              <Form.Group as={Col} xs={12} md>
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Fecha de fin"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control type="date" min={startDate} value={endDate} onChange={handleChangeEndDate} />
                </InputGroup>
              </Form.Group>

            </Form.Row>}
          </Form>
        </Navbar.Collapse>
      </CustomNavBar>
      {/*vista tabla hermanas en la comunidad actualmente */}
      <CustomTable ref={scrollingDiv}>
        <TablaDestinos
          idEntidad={idEntidad}
          idSubEntidad={idSubEntidad}
          type={type}
          datosHermanas={datosHermanasComunidad}

          handlePutDestino={permisoEdicion ? handlePutDestino : null}
          handleDelDestino={permisoEdicion ? handleDelDestino : null}
          permisoEdicion={permisoEdicion}
        />
        <br ref={target} id="observable" />
      </CustomTable>

      <div className="d-flex justify-content-end">
        {permisoEdicion && <Button
          variant="outline-primary"
          className={"mr-2"}
          size="sm"
          onClick={() => {
            modalSetShow(true, "80%");
            modalSetTitle(`Añadir hermana`);
            modalSetContent(              
              <FormDestino
                idEntidad={idEntidad}
                idSubEntidad={idSubEntidad}
                type={type}
                submissionHandler={handlePostDestino}
                defaultValues={{ startDate: dateToString2(new Date()), endDate: handlerEndDate() ? dateToString2(addYears(new Date(), handlerEndDate())) : "" }}
                handlerEndDate={handlerEndDate}
                noControl={false}
                userLevel = {userLevel}
              />
            );
          }}
        >
          
          {`Añadir hermana`}
        </Button>}

      </div>
    </div>
  );
};

export default DestinosComunitarios;
